<template>
  <div class="ma-0">
    <titleAgency></titleAgency>
    <v-tabs
      v-model="tab"
      color="#2BA197"
      style="margin-top: 0px;"
      background-color="titlebackground"
    >

    <v-tabs-slider class="ml-4" color="#2BA197"></v-tabs-slider>

    <v-tab v-for="item in items" :key="item.nameBusiness" style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">
      <span class="ml-5">{{ item.nameBusiness }}</span>
      <!-- <v-chip
        class="ml-2"
        color="#fff"
        text-color="#0370B7"
        small
      >
        <span>{{item.total}}</span>
      </v-chip> -->
    </v-tab>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="my-0">
          <div>
            <!-- <tableAgency/> -->
            <filterAgency class="mx-5 mt-5"/>
            <tableAgency class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="my-0">
          <div>
            <filterManage class="mx-5 mt-5"/>
            <tableManage class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="my-0">
          <div>
            <filterReceive class="mx-5 mt-5"/>
            <tableReceive class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</div>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_managetransferrole/_overview/title.vue'
import filterAgency from '@/components/_managetransferrole/_overview/filter.vue'
import filterManage from '@/components/_managetransferrole/_overview/filterManage.vue'
import filterReceive from '@/components/_managetransferrole/_overview/filterReceive.vue'
import tableAgency from '@/components/_managetransferrole/_overview/table.vue'
import tableManage from '@/components/_managetransferrole/_overview/tableManage.vue'
import tableReceive from '@/components/_managetransferrole/_overview/tableReceive.vue'
export default {
  components: {
    titleAgency,
    filterAgency,
    filterManage,
    filterReceive,
    tableAgency,
    tableManage,
    tableReceive
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true,
      tab: null,
      items: [
        {
          id: 1,
          nameBusiness: 'รายการอนุมัติสิทธิ์'
        },
        {
          id: 2,
          nameBusiness: 'จัดการ Tag'
        },
        {
          id: 3,
          nameBusiness: 'สิทธิ์ที่ได้รับ'
        }
      ],
      approveRole: localStorage.approveRole
      // items: [
      //   'ธุรกิจ(ร้านค้า)', 'นิติบุคคล'
      // ]
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getBusinessCount()
  },
  beforeDestroy () {
    EventBus.$off('countBusiness')
    EventBus.$off('setApproveRole')
  },
  mounted () {
    EventBus.$on('countBusiness', this.getBusinessCount)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  tab: function (val) {
    this.forceRerender()
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      await this.getBusinessCount()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
        localStorage.setItem('approveRole', 'Admin')
        EventBus.$emit('updateNavbarRole', 'Admin')
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
        localStorage.setItem('approveRole', 'Leader')
        EventBus.$emit('updateNavbarRole', 'Leader')
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    },
    async getBusinessCount () {
      const obj = {
        role: this.approveRole
      }
      try {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/companys/countBusinessAndReqBusiness`,
          data: obj,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          if (response.data.success) {
            // this.items = response.data.result.getBusiness
          } else {
            // console.log(response)
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
